const initialState = {
  masterValueData: null,
  electricityCharge: null,
  otherCharges: null,
  isLoading: false,
  error: null,
  uploadDataNewTariff:null
};

const newTariffReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_DATA_NEWTARIFF':
      return { ...state, masterValueData: action.payload, isLoading: false };
    case 'SET_DATA_ELECTRICITY_CHARGES':
      return { ...state, electricityCharge: action.payload, isLoading: false };
    case 'SET_DATA_OTHER_CHARGES':
      return { ...state, otherCharges: action.payload, isLoading: false };
    case 'FETCH_DATA_SUCCESS':
      return { ...state, data: action.payload, isLoading: false };
    case 'FETCH_DATA_FAILURE':
      return { ...state, error: action.payload, isLoading: false };
    case 'UPLOAD_DATA_NEWTARIFF':
      return { ...state, uploadDataNewTariff: action.payload, isLoading: false };
    default:
      return state;
  }
};

export default newTariffReducer;